export default __webpack_public_path__ + "static/media/logo_light.73b062cf.png";